import naturaFoodsHp from "../../../assets/natura-foods-hp.jpg";

export default function News() {
  return (
    <section
      id="news"
      className="relative py-12 md:py-14 bg-background-100 border-y border-background-200"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-[1fr_auto] gap-6 md:gap-8 items-center bg-background-50 rounded-2xl p-5 md:p-7 border border-background-200">
          <div>
            <div className="inline-flex items-center gap-2 mb-2">
              <span className="font-label tracking-widest text-foreground-500 text-xs">
                NEWS
              </span>
            </div>
            <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-900 leading-snug">
              最新情報・過去の店舗情報は運営会社サイトでもご覧いただけます
            </h2>
            <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
              「株式会社なちゅらフーズ」公式サイトでは、他店舗の情報やお知らせも掲載しています。
            </p>
            <a
              href="https://natura-foods.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-1.5 min-h-[44px] text-primary-700 font-heading font-bold text-sm cursor-pointer underline underline-offset-2"
            >
              運営会社サイトを見る
              <i className="ri-external-link-line" aria-hidden="true"></i>
            </a>
          </div>

          {/* Mockup: small site thumbnail */}
          <div className="hidden sm:block w-32 md:w-40 shrink-0">
            <div className="rounded-lg overflow-hidden border border-background-200 aspect-video bg-background-100">
              <img
                src={naturaFoodsHp}
                alt="株式会社なちゅらフーズ 公式ホームページ"
                width={320}
                height={180}
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
